<template>
  <button :type="buttonType" class="relative border rounded-3xl px-4 py-0.5 w-fit block font-medium text-lg flex items-center" :style="['background-color:' + bgColor, 'color: ' + labelColor, 'border: ' + borderColor]">
    <slot></slot>
    <span :class="[buttonIcon.position ? buttonIcon.position : 'mr-1']" v-if="Object.keys(buttonIcon).length != 0"> <img :src="commonStore.getImgUrl(buttonIcon.componentName, buttonIcon.imgName, buttonIcon.imgFormat)" :style="'width:' + buttonIcon.width" /></span>
    <span :style="['width: ' + buttonWidth]">{{ t(label) }}</span>
  </button>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useCommonStore } from "@/stores/common";

import { useI18n } from "vue-i18n";

const commonStore = useCommonStore();
const { t, locale } = useI18n();

onMounted(async () => {});

import { toRefs } from "vue";

const props = defineProps({
  buttonType: {
    type: String,
    default: "button",
  },
  buttonIcon: {
    type: Object,
    default: {},
  },
  bgColor: {
    type: String,
    default: "#494949",
  },
  buttonWidth: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
  labelColor: {
    type: String,
    default: "#FFFFFF",
  },
  borderColor: {
    type: String,
    default: "2px solid transparent",
  },
});
//const { label } = toRefs(props);
</script>

<style>
</style>